<template>
  <div id="contourEditPanel">
    <div class="titleBar">
      <span class="titleIcon glyphicons glyphicons-vector-path-polygon"></span>
      <span class="titleText">{{ $t('map.DrawContour.ContourActions.editPanel.title', { 0: contourName }) }}</span>
    </div>

    <div class="panelBody">
      <ul class="helpList">
        <li>
          <span class="helpIcon glyphicons glyphicons-hand-up"></span>
          {{ $t('map.DrawContour.ContourActions.editPanel.move') }}
        </li>
        <li>
          <span class="helpIcon glyphicons glyphicons-plus"></span>
          {{ $t('map.DrawContour.ContourActions.editPanel.add') }}
        </li>
        <li>
          <span class="helpIcon glyphicons glyphicons-mouse-right-click"></span>
          {{ $t('map.DrawContour.ContourActions.editPanel.remove') }}
        </li>
      </ul>

      <p v-if="notice" class="notice" role="status">
        <span class="glyphicons glyphicons-info-sign"></span>
        {{ notice }}
      </p>

      <div class="panelFooter">
        <span class="savedNote">
          <span class="glyphicons glyphicons-ok"></span>
          {{ $t('map.DrawContour.ContourActions.editPanel.saved') }}
        </span>
        <button type="button" class="doneButton" @click="$emit('done')">
          {{ $t('map.DrawContour.ContourActions.editPanel.done') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contour-edit-panel',

  props: {
    contourName: {
      type: String,
      required: true
    },
    notice: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="less">
#contourEditPanel {
  // Under the search bar, lined up with it: the contour being edited is usually in the middle of the
  // map, and the layer and legend buttons take the bottom left.
  position: absolute;
  z-index: 2;
  top: 55px;
  left: 90px;
  width: 320px;
  max-width: calc(100% - 110px);
  background-color: @white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  overflow: hidden;

  // glyphicons.css pads every icon by 6px 8px, which pushes these small icons off centre.
  .glyphicons:before {
    display: inline-block;
    padding: 0 4px;
  }

  .titleBar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: @primaryGreen;
    color: @white;
    font-weight: bold;

    .titleIcon {
      flex: 0 0 auto;
      font-size: 18px;
    }

    .titleText {
      overflow-wrap: anywhere;
    }
  }

  .panelBody {
    padding: 10px 12px;
    color: @gray800;
  }

  .helpList {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 3px 0;
    }
  }

  .helpIcon {
    flex: 0 0 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    background-color: @greenTerra100;
    color: @greenTerra800;
    font-size: 13px;
    text-align: center;
  }

  .notice {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 8px 0 0;
    padding: 6px 8px;
    border-radius: 4px;
    background-color: @warning50;
    color: @warning800;
  }

  .panelFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid @gray200;
  }

  .savedNote {
    display: flex;
    align-items: center;
    gap: 6px;
    color: @gray500;
    font-size: 12px;

    .glyphicons {
      color: @primaryGreen;
    }
  }

  .doneButton {
    flex: 0 0 auto;
    padding: 5px 18px;
    border: none;
    border-radius: 4px;
    background-color: @primaryGreen;
    color: @white;
    font-weight: bold;

    &:hover,
    &:focus {
      background-color: @greenTerra700;
    }
  }
}
</style>
